import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'slnk-shared-input-validator',
    templateUrl: './shared-input-validator.component.html',
    styleUrls: ['./shared-input-validator.component.scss'],
    standalone: false
})
export class SharedInputValidatorComponent implements OnInit {

  @Input() validationFormControl: UntypedFormControl;

  constructor() {
  }

  ngOnInit() {
  }

}
